export const RunFailureForensicsTestIds = {
  RETRY_CANCEL_BUTTON: 'run-failure.retry-cancel-button',
  RETRY_FROM_HERE_CANCEL_BUTTON: 'run-failure.retry-from-here-cancel-button',
};
